<template>
  <div v-bind:class="cardClass">
    <div>
      <h1 class="card-title">{{title}}</h1>
      <hr />
    </div>

    <div id="price-container">
      <p v-if="originalPrice">מחיר מקורי :</p>
      <strike v-if="originalPrice">₪{{formmatedOriginalPrice}}</strike>
      <h2>₪ {{formmatedPrice}}</h2>
      <p id="price-description">{{description}}</p>
    </div>

    <ul id="feature-list">
      <li v-for="feature in features" v-bind:key="feature">
        <img v-if="mapType === 'green'" src="../assets/green_vee_spot.svg" class="feature-img" />
        <img v-if="mapType === 'blue'" src="../assets/blue_vee_spot.svg" class="feature-img" />
        <img v-if="mapType === 'yellow'" src="../assets/gold_vee_spot.svg" class="feature-img" />
        <p>{{feature}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PackageCard",
  props: [
    "title",
    "description",
    "isDiscounted",
    "originalPrice",
    "price",
    "features",
    "mapType"
  ],
  data: () => {
    return {};
  },
  computed: {
    formmatedPrice() {
      return `${Number(this.price) - 1}.99`;
    },
    formmatedOriginalPrice() {
      return `${Number(this.originalPrice) - 1}.99`;
    },
    cardClass: function() {
      return {
        green: this.mapType === "green",
        blue: this.mapType === "blue",
        yellow: this.mapType === "yellow",
        card: true
      };
    }
  }
};
</script>

<style>
h1 {
  font-size: 48px;
  color: white;
}

.feature-img {
  height: 18px;
  width: 18px;
  vertical-align: text-top;
  margin-left: 18px;
}

h2 {
  color: white;
  font-size: 64px;
  margin-bottom: 18px;
  margin-top: 24px;
}

p,
strike {
  color: white;
  font-size: 18px;
  display: inline;
}

.card-title {
  text-align: center;
  white-space: nowrap;
  margin-top: 8px;
}

#price-container {
  margin-top: 4vh;
  text-align: center;
  margin-bottom: 32px;
}

.green {
  background: rgb(136, 146, 71);
  background: linear-gradient(
    0deg,
    rgba(138, 197, 88, 1) 0%,
    rgba(136, 146, 71, 1) 100%
  );
}

.yellow {
  background: rgb(255, 190, 59);
  background: linear-gradient(
    0deg,
    rgba(255, 226, 55, 1) 0%,
    rgba(255, 190, 59, 1) 100%
  );
}

.blue {
  background: rgb(12, 214, 216);
  background: linear-gradient(
    0deg,
    rgba(12, 214, 216, 1) 0%,
    rgba(7, 150, 200, 1) 100%
  );
}

.card {
  padding: 24px;
  width: 100%;
  height: 720px;
  transition: transform 0.3s;
  border-radius: 17.6px;
  box-shadow: 0 2px 10px 1px hsla(0, 0%, 55.3%, 0.3),
    0 2px 10px 3px rgba(0, 0, 0, 0.5);
  margin-top: auto;
  margin-bottom: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
}

.card:hover {
  transform: scale(1.05);
}

/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  /* Styles */
  .card {
    height: auto;
  }

  .card:hover {
    transform: scale(1);
  }
}

#feature-list {
  margin-top: auto;
  text-align: center;
  list-style-type: none;
  padding-right: 0px;
}

ul li {
  direction: rtl;
}

ul {
  direction: rtl;
}
</style>